<template src="../templates/normal_fcont_99.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import CreatorProfileVosges from '../components/CreatorProfileVosges'
import PrintButton from '../components/PrintButton'
import UseDesignPaperList from '../components/UseDesignPaperList'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'

import { Carousel,Slide } from 'uiv'


export default {
  name: 'app',
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,FuncSearchGalleryQR,
    CreatorProfileVosges,PrintButton,UseDesignPaperList
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['99-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['99-2']}
    ]};

  }
};
</script>
<style >

</style>

